export default __webpack_public_path__ + "static/media/Tasset of the Fallen Empire (nm).901193e7.jpg";